<template>
  <figure>
    <template v-for="(childNode, index) in node.children">
      <ContentVideo
        v-if="childNode.tagName === 'video'"
        :key="index"
        :video="getVideo(childNode.attributes.dataset.videoId)"
      />
      <ContentImage
        v-if="childNode.tagName === 'img'"
        :key="index"
        :image="getImage(childNode.attributes.dataset.imageId)"
      />
      <span
        v-if="isIframe(childNode)"
        :key="index"
        v-html="getHTML(childNode)"
      />
    </template>
  </figure>
</template>

<script>
import translate from 'himalaya/translate';

export default {
  name: 'figure-content',

  props: [
    'node',
    'page',
  ],

  methods: {
    getHTML(childNode) {
      return translate.toHTML(childNode);
    },

    getVideo(videoId) {
      return this.page.videos.find(video => video.id === videoId);
    },

    getImage(imageId) {
      return this.page.images.find(image => image.id === imageId);
    },

    getAudio(audioId) {
      return this.page.audios.find(audio => audio.id === audioId);
    },

    isIframe(childNode) {
      return (childNode.tagName === 'span' &&
          childNode.children &&
          childNode.children.length > 0 &&
          childNode.children[0].tagName === 'iframe');
    },
  },
};
</script>
